import React from 'react';
import PropTypes from 'prop-types';
import { PlaysWrapper } from './Plays.style';
import { PlayDataContainer } from '../../Play';

// Plays component will render a set of plays from an array of indicies.
// Created by PlayFeed for every half-inning array.
const Plays = ({
    playArr = [],
    teams,
    offset,
    reverseChron = false,
    showKeyMoment = false,
    openAtBatOverlay
}) => {
    const orderedPlayArr = reverseChron ? [...playArr].reverse() : playArr;
    return (
        <PlaysWrapper>
            {
                orderedPlayArr.map((index) => {
                    return (
                        <PlayDataContainer
                            key={ `play-${index}` }
                            dataIndex={ index }
                            teams={ teams }
                            offset={ offset }
                            reverseChron={ reverseChron }
                            showKeyMoments={ showKeyMoment }
                            openAtBatOverlay={ openAtBatOverlay }
                        />
                    );
                })
            }
        </PlaysWrapper>
    );
};

Plays.propTypes = {
    playArr: PropTypes.arrayOf(PropTypes.number),
    teams: PropTypes.object,
    offset: PropTypes.bool,
    reverseChron: PropTypes.bool,
    showKeyMoment: PropTypes.bool
};

export default Plays;
